module.exports = __webpack_public_path__ + "img/delete.838052b3.svg";